//
// class for DataFormat2Logdilution data type
//
// @extends [DataFormatNumber]
//

import { DataFormatNumber } from './DataFormatNumber';

/**
 * Data formatter for DataFormat2Logdilution type.
 * @ignore
 */
export class DataFormat2Logdilution extends DataFormatNumber
{
    getName() : string
    {
        return "2Logdilution";
    }
}

export default DataFormat2Logdilution;
